import { CURRENT_USER } from "constants/storageKeys";

const MAGIC_LINK_DATA_KEY = "magicLinkData";

export const handOffToV1Signup = (): void => {
  try {
    const stored = localStorage.getItem(CURRENT_USER);
    if (!stored) return;

    const user = JSON.parse(stored);

    localStorage.setItem(
      MAGIC_LINK_DATA_KEY,
      JSON.stringify({
        email: user?.email ?? "",
        first_name: user?.first_name ?? "",
        last_name: user?.last_name ?? "",
        uuid: user?.uuid ?? "",
      })
    );
  } catch {}
};
